module.exports = __webpack_public_path__ + "static/media/slide6.7f04449b.jpg";